import React from 'react'
import {Box, Form } from 'grommet'
import countries from '../../components/countries.json'


const defaultOptions = [];



class Quote extends React.Component {
  state = {
    value: '',
    origin: '',
    destination: '',
    options: countries.countries.map(c => {
      defaultOptions.push(`${c.countryName}`)
      return defaultOptions
    }),
    defaultOptions: countries.countries.map(c => {
      defaultOptions.push(`${c.countryName}`)
      return defaultOptions
    })
  }
  render(){
    return (
      <Box direction='row' justify="start" margin='small'>
        <Box direction='column'>
       </Box>
        <Form>
       </Form>
      </Box>
    )
  }
}

export default Quote
